<template>
  <a-card title="社区主贴" >
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="Article ID" v-model:value="formSearch.id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="作者 ID" v-model:value="formSearch.user_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="帖子标题" v-model:value="formSearch.title" />
        </a-form-item>
        <a-form-item  label="状态">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.is_delete"
          :options="[{label: '正常', value: '0'}, {label: '删除', value: '1'}, {label: '所有', value: ''}]"
          placeholder="帖子状态"
        />
      </a-form-item>
      <a-form-item  label="排序">
        <a-select
          :allowClear="true"
          style="width: 130px;"
          v-model:value="formSearch.orderby"
          :options="[{label: '发布时间倒序', value: 'created_at desc'}, {label: '推荐顺序倒序', value: ''}]"
          placeholder="排序"
        />
      </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
       show-quick-jumper
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #id="{ record }">
          {{ record.id }}
          <!-- <a @click="handelToComments(record.id)" >查看评论</a> -->
        </template>
        <template #base_img_key="{ record }">
          <a-image
              v-if="record.base_img_key"
              style="width: 150px"
              placehoder=false
              :preview='{src: rawImage(record.base_img_key)}'
              :src="thumbnail(record.base_img_key)"
            />
        </template>
        <template #work_img_key="{ record }">
          <a-image
              v-if="record.work_img_key"
              style="width: 150px"
              placehoder=false
              :preview='{src: rawImage(record.work_img_key)}'
              :src="thumbnail(record.work_img_key)"
            />
        </template>
        <template #prompt="{ record }">
          <div >
              <div style="font-weight: bold;">{{ record.title }}</div>
              <div>{{ record.desc }}</div>
              <hr />
              <div>Prompt: {{ record.prompt }}</div>
            </div>
          
        </template>
        <template #sort_order="{ record }">
          <a-input-group compact  style="width: 160px;">
            <a-input-number v-model:value="record.sort_order" style="width: 60px;" />
            <a-button type="primary" @click="handleSetSort(record)"  >设置</a-button>
          </a-input-group>
        </template>
        <template #created_at="{ record }">
          <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
          <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
        </template>
        <template #is_delete="{ record }">
          <a-tag v-if="record.is_delete == 1" color="red">已删除</a-tag>
          <a-tag v-else color="green">正常</a-tag>
        </template>
        <template #comment_count="{ record }">
          <a v-if="record.comment_count > 0"  @click="handelToComments(record.id)" >{{ record.comment_count }}</a>
          <span v-else>{{ record.comment_count }}</span>
        </template>
        <template #action="{ record }">
          <a-space>
              <a-button @click="handleToPostConfig(record)">模板配置</a-button>
              <a-popconfirm
              title="确定删除吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleDelete(record)"
            >
              <a-button v-if="record.is_delete == 0"   danger   >删除</a-button>
            </a-popconfirm>
            <a-popconfirm
              title="确定恢复吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleRestore(record)"
            >
              <a-button v-if="record.is_delete == 1"   danger   >恢复</a-button>
            </a-popconfirm>
          </a-space>
        </template>
        <template #expandedRowRender="{record}">
        <div>
          <div v-for="(value, key) of record" :key="key">
            <a-row v-if="value != ''">
              <a-col :span="2" >{{ key }}:</a-col>
              <a-col :span="10" >{{ value }}</a-col>
            </a-row>
          </div>
        </div>
      </template>
      <template #operator="{ record }">
        <a target="_blank" :href="`/home/user?user_id=${record.operator}`">{{Operators[record.operator] ? Operators[record.operator] : record.operator}}</a>
      </template>
      </a-table>
  </a-card>

  <a-modal v-model:open="lookup_order_open" title="苹果订单信息" @ok="lookup_order_open = false">
    <a-tag  color="red" >transactionId: {{ lookup_order.transactionId }}</a-tag>  
    <pre>{{ lookup_order }}</pre>
    </a-modal>
</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { thumbnail, rawImage } from '@/utils/image'
import {Operators} from '@/utils/macro'

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    return {
      Operators,
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
       formSearch: {
        user_id: '',
        title: '',
        id: '',
        orderby: '',
        is_delete: ''
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  computed:{},
  methods: {
    handelToComments: function(id){
      this.$router.push({
        path: '/community/comment',
        query: {
          article_id: id
        }
      })
    },
    handleToPostConfig: function(record){
      this.$router.push({
        path: '/community/post-config'
      })
    },
    thumbnail,
    rawImage,
    handleDelete: function(record) {
      this.loading = true
      request.delete('/api/community/articles/' + record.id).then((rsp) => {
        record.is_delete = 1
        // this.noticeMessage = '删除成功'
      }).catch((err) => {
        // this.noticeMessage = '删除失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSetSort: function(record) {
      this.loading = true
      request.post('/api/community/articles/' + record.id + '/sort_order', {
        "sort_order": +record.sort_order
      }).then((rsp) => {
        // record.is_delete = 1
        // this.noticeMessage = '删除成功'
      }).catch((err) => {
        // this.noticeMessage = '删除失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleRestore: function(record) {
      this.loading = true
      request.post('/api/community/articles/' + record.id + '/restore').then((rsp) => {
        // this.handleTableChange()
        record.is_delete = 0
        // this.noticeMessage = '删除成功'
      }).catch((err) => {
        // this.noticeMessage = '删除失败'
      }).finally(() => {
        this.loading = false
      })
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      if (!pagi) {
        pagi = this.pagination
      }
      this.loading = true
      const rsp = await request.get('/api/community/articles', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch,
        is_delete: +this.formSearch.is_delete
      })
      for (let item of rsp.data.list) {
        item.created_at = new Date(item.created_at)
        item.updated_at = new Date(item.updated_at)
      }
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
        {
          title: '主贴 ID',
          dataIndex: 'id',
          key: 'id',
          slots: { customRender: 'id' },
        },
        {
          title: '用户 ID',
          key: 'user_id',
          dataIndex: 'user_id',
        },
        {
          title: '用户昵称',
          key: 'nickname',
          dataIndex: 'nickname',
        },
        // {
        //   title: '标题',
        //   dataIndex: 'title',
        //   key: 'title',
        // },
        // {
        //   title: '内容',
        //   key: 'desc',
        //   dataIndex: 'desc',
        // },
         {
          title: '原图',
          key: 'base_img_key',
          dataIndex: 'base_img_key',
          slots: { customRender: 'base_img_key' },
        },
         {
          title: '封面',
          key: 'work_img_key',
          dataIndex: 'work_img_key',
          slots: { customRender: 'work_img_key' },
        },
        {
          title: '标题',
          key: 'title',
          dataIndex: 'title',
        },
       
         {
          title: '内容',
          key: 'desc',
          dataIndex: 'desc',
        },
       
         {
          title: '评论',
          key: 'comment_count',
          dataIndex: 'comment_count',
          slots: { customRender: 'comment_count' },

        },
         {
          title: '推荐值',
          key: 'sort_order',
          dataIndex: 'sort_order',
          slots: { customRender: 'sort_order' },
        },
         {
          title: '状态',
          key: 'is_delete',
          dataIndex: 'is_delete',
          slots: { customRender: 'is_delete' },
        },
       
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },

        },
         {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          slots: { customRender: 'operator' },

        },
         {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },

        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>
